export const SESSION_STORAGE_KEY = 'WHOAMI_TODAY_SCROLL_POSITION';
